import type { SelectOptionObject } from './utils'

export type PagesOptions = {
  pages: SelectOptionObject[]
}

export default {
  pages: [],
} as PagesOptions
